import {GridColumns, GridRenderCellParams} from '@mui/x-data-grid';
import {FormattedMessage} from 'react-intl';
import {ConsumptionPaymentMode, RegistrationStatusEnum} from 'src/enums';
import dayjs from 'dayjs';
import {EmployeeStatus} from './EmployeeStatus/EmployeeStatus';
import {PaymentModeStatus} from './PaymentModeStatus';
import {EmployeeActions} from './EmployeeActions';
import {EmployeeCell} from '../users/EmployeeCell';

export const columnConfigEmployees = (): GridColumns => [
    {
        field: 'FIRST_NAME',
        renderHeader: (_params) => <FormattedMessage id={'nameColumnHeader'}/>,
        flex: 2,
        minWidth: 200,
        sortable: true,
        cellClassName: 'ampTableCell',
        renderCell: (params) => <EmployeeCell data={params.row}/>,
    },
    {
        field: 'email',
        sortable: false,
        renderHeader: (_params) => <FormattedMessage id={'emailColumnHeader'}/>,
        flex: 2,
        minWidth: 200,
        cellClassName: 'ampTableCell',
        valueGetter: (params) => params.row.user.emailAddress,
    },
    {
        field: 'CREATED_AT',
        sortable: true,
        renderHeader: (_params) => <FormattedMessage id={'dateColumnHeader'}/>,
        flex: 1,
        minWidth: 100,
        cellClassName: 'ampTableCell',
        valueGetter: (params) => dayjs(params.row.user.created).format('DD/MM/YY'),
    },
    {
        field: 'status',
        sortable: false,
        renderHeader: (_params) => <FormattedMessage id={'statusColumnHeader'}/>,
        flex: 1,
        minWidth: 100,
        cellClassName: 'ampTableCell',
        renderCell: (params) => (
            <EmployeeStatus label={params.row.user.registrationStatus as RegistrationStatusEnum}/>
        ),
    },
    {
        field: 'consumptionPaymentMode',
        sortable: false,
        renderHeader: (_params) => <FormattedMessage id={'paymentModeColumnHeader'}/>,
        flex: 1.4,
        minWidth: 120,
        cellClassName: 'ampTableCell',
        renderCell: (params) => (
            <PaymentModeStatus label={params.row.consumptionPaymentMode as ConsumptionPaymentMode}/>
        ),
    },
    {
        field: 'actions',
        width: 120,
        headerName: '',
        sortable: false,
        cellClassName: 'ampTableCell',
        align: 'right' as const,
        headerAlign: 'right' as const,
        renderCell: (params: GridRenderCellParams) => <EmployeeActions row={params.row}/>,
    },
];
